"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Counter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("../../../hooks");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Counter = _ref => {
  let {
    from,
    to,
    duration
  } = _ref;
  const count = (0, _hooks.useCounter)(from, to, {
    duration
  });
  return /*#__PURE__*/_react.default.createElement("span", null, count);
};

exports.Counter = Counter;
Counter.defaultProps = {
  from: 0,
  to: 100,
  duration: 2500
};
Counter.propTypes = {
  from: _propTypes.default.number,
  to: _propTypes.default.number,
  duration: _propTypes.default.number
};